<template>
  <v-row>
    <v-col cols="12" v-for="(instance, i) in survey.instances" :key="i">
      <v-card
        outlined
        :to="
          instance.sentDate
            ? `/reporting/surveys/overview/surveys/${survey.id}/sends/${instance.id}`
            : null
        "
      >
        <v-container class="py-0">
          <v-row dense>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-chip
                small
                :color="chipColor(instance)"
                :dark="chipDark(instance)"
                >{{ chipText(instance) }}
              </v-chip>
            </v-col>
            <v-col class="my-auto">
              {{ lineText(instance) }}
            </v-col>
            <v-spacer class="limited-spacer"></v-spacer>
            <v-col v-if="instance.sentDate != null" class="my-auto">
              <simple-engagement-text
                :engagement="instance.userRecords"
              ></simple-engagement-text>
            </v-col>
            <v-col cols="auto">
              <v-menu absolute>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" v-on:click.prevent icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="instance.sentDate == null && instance.canSave"
                    @click="$emit('edit', instance.id)"
                  >
                    <v-list-item-title>Edit Schedule</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      !instance.liveLink &&
                        instance.sentDate != null &&
                        !instance.isComplete &&
                        instance.canSave
                    "
                    @click="$emit('addRecipients', instance.id)"
                  >
                    <v-list-item-title>Add Recipients</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      instance.sentDate != null &&
                        instance.liveLink &&
                        !instance.isComplete
                    "
                    @click="$emit('viewlink', instance.id)"
                  >
                    <v-list-item-title>View Info</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="instance.sentDate != null"
                    :to="
                      `/reporting/surveys/overview/surveys/${survey.id}/sends/${instance.id}`
                    "
                  >
                    <v-list-item-title>View Responses</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      instance.sentDate != null &&
                        !instance.isComplete &&
                        instance.canSave
                    "
                    @click.prevent="$emit('close', instance.id)"
                  >
                    <v-list-item-title>Close</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="instance.sentDate == null && instance.canSave"
                    @click.prevent="$emit('delete', instance.id)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import dateFilter from "@/helpers/filters/date";
import SimpleEngagementText from "@/components/reporting/SimpleEngagementText";
export default {
  name: "SurveyCardInstances",
  components: { SimpleEngagementText },
  props: { survey: { type: Object } },
  data: () => ({ loading: false }),
  computed: {
    chipDark() {
      return instance => {
        return !instance.isComplete && instance.liveLink;
      };
    },
    chipColor() {
      return instance => {
        if (instance.isComplete) {
          return "lighttext";
        } else if (instance.liveLink) {
          return "performance";
        } else if (instance.sentDate != null) {
          return "success";
        }
        return "primary";
      };
    },
    chipText() {
      return instance => {
        if (instance.isComplete) {
          return "Complete";
        } else if (instance.liveLink) {
          return "Live";
        } else if (instance.sentDate != null) {
          return "Sent";
        }
        return "Scheduled";
      };
    },
    lineText() {
      return instance => {
        if (instance.isComplete) {
          return `Sent on ${dateFilter.longDateWithTime(
            instance.sentDate
          )} and Completed on ${dateFilter.longDate(instance.finishDate)}`;
        } else if (instance.sentDate != null) {
          return `Sent on ${dateFilter.longDateWithTime(instance.sentDate)}`;
        }
        return `Scheduled for ${dateFilter.longDateWithTime(
          instance.scheduledDate
        )}`;
      };
    },
    completion() {
      return instance => {
        return (instance.userRecords || { completion: 0 }).completion;
      };
    },
    ...mapGetters({})
  },
  mounted() {
    if ((this.survey.instances || []).length > 0) {
      return;
    }
    this.loadInstances();
  },
  methods: {
    loadInstances() {
      this.loading = true;
      this.$store
        .dispatch("survey/getSurveyInstances", this.survey.id)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading survey activity."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
